import { FieldVisibility, TablePropertyFields } from '../dataTypes';

export const DefaultInvoiceColumnSettings: TablePropertyFields = {
  tablePropertyFields: [
    {
      id: 'client',
      name: 'Recipient',
      disabled: false,
    },
    {
      id: 'amount',
      name: 'Amount',
      disabled: false,
    },
    {
      id: 'status',
      name: 'Status',
      disabled: false,
    },
    {
      id: 'invoiceNumber',
      name: 'Invoice number',
      disabled: false,
    },
    {
      id: 'created',
      name: 'Created',
      disabled: false,
    },
    {
      id: 'due',
      name: 'Due',
      disabled: false,
    },
    {
      id: 'paymentDate',
      name: 'Payment',
      disabled: false,
    },
    {
      id: 'type',
      name: 'Type',
      disabled: true,
    },
    {
      id: 'paymentFee',
      name: 'Payment fees',
      disabled: true,
    },
    {
      id: 'clientPaymentFee',
      name: 'Client payment fees',
      disabled: true,
    },
    {
      id: 'currency',
      name: 'Currency',
      disabled: true,
    },
    {
      id: 'memo',
      name: 'Memo',
      disabled: true,
    },
    {
      id: 'taxPercentage',
      name: 'Tax percent',
      disabled: true,
    },
  ] as FieldVisibility[],
};
